import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sanitation-reports--focus-section"
export default class extends Controller {
  static targets = ["section", "focusButton", "clearButton"]

  connect() {
    this.#resetSections()
    this.#syncButtons(null)
  }

  focus(event) {
    event.preventDefault()

    const sectionId = event.params.sectionId || event.currentTarget.dataset.sectionId
    this.sectionTargets.forEach((section) => {
      const selected = section.dataset.sectionId === sectionId
      FOCUSED_SECTION_CLASSES.forEach((klass) => {
        section.classList.toggle(klass, selected)
      })
    })

    this.#syncButtons(sectionId)
    this.#resizeCharts()
  }

  clear(event) {
    event?.preventDefault()

    this.#resetSections()
    this.#syncButtons(null)
    this.#resizeCharts()
  }

  #resetSections() {
    this.sectionTargets.forEach((section) => {
      FOCUSED_SECTION_CLASSES.forEach((klass) => {
        section.classList.remove(klass)
      })
    })
  }

  #syncButtons(focusedSectionId) {
    this.focusButtonTargets.forEach((button) => {
      button.classList.toggle("hidden", button.dataset.sectionId === focusedSectionId)
    })

    this.clearButtonTargets.forEach((button) => {
      button.classList.toggle("hidden", button.dataset.sectionId !== focusedSectionId)
    })
  }

  #resizeCharts() {
    requestAnimationFrame(() => {
      window.dispatchEvent(new Event("resize"))
    })
  }
}

const FOCUSED_SECTION_CLASSES = ["lg:col-span-2", "xl:col-span-3"]
